import { render } from "./MovieCardsList.vue?vue&type=template&id=167764e2&scoped=true"
import script from "./MovieCardsList.vue?vue&type=script&lang=js"
export * from "./MovieCardsList.vue?vue&type=script&lang=js"

import "./MovieCardsList.vue?vue&type=style&index=0&id=167764e2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167764e2"]])

export default __exports__